import { VerticalListIcon } from '@/features/experiences/components/Controls/controls/LayoutControl/VerticalListIcon';

export const ListVerticalIcon = () => {
  return <VerticalListIcon numRows={7} />;
};
